(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-chart-component')) {
    class SizeChartComponent extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-size-chart-open]');
        if (!this.dialog || !this.trigger) return;

        this.trigger.addEventListener('click', () => this.open());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target.closest('[data-size-chart-close]')) this.close();
          const unitButton = event.target.closest('[data-size-chart-unit]');
          if (unitButton) this.setUnit(unitButton.dataset.sizeChartUnit);
        });
        this.dialog.addEventListener('close', () => this.trigger.focus());

        this.onEditorSelect = (event) => {
          if (event.target === this || this.contains(event.target)) this.open();
        };
        this.onEditorDeselect = (event) => {
          if (event.target === this || this.contains(event.target)) this.close();
        };
        document.addEventListener('shopify:block:select', this.onEditorSelect);
        document.addEventListener('shopify:block:deselect', this.onEditorDeselect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onEditorSelect);
        document.removeEventListener('shopify:block:deselect', this.onEditorDeselect);
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.dialog.querySelector('[data-size-chart-close]')?.focus();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      setUnit(unit) {
        this.querySelectorAll('[data-size-chart-unit]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.sizeChartUnit === unit));
        });
        this.querySelectorAll('[data-size-chart-table]').forEach((table) => {
          table.hidden = table.dataset.sizeChartTable !== unit;
        });
      }
    }

    customElements.define('size-chart-component', SizeChartComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
